module.exports = __webpack_public_path__ + "img/ddh.019c73e6.jpg";